import React, { useEffect, useState } from 'react'
import { Button, Card } from 'react-bootstrap'
import { doRequestGet, doRequestPost } from '../../../api'
import { doToast, getDate } from '../../../utils'
import { FormCustom, Input } from '../../../components/form'
import LoadingIcon from '../../../components/loading/LoadingIcon'
import { toast } from 'react-toastify'
import SelectCustom from '../../../components/select-custom/SelectCustom'

export const ReporteGeneralView = () => {
  const [form, setForm] = useState({
    p_id_worker: '',
    p_id_event: '',
    p_date_start: getDate(),
    p_date_end: getDate(),
  })

  const [report, setReport] = useState({})
  const [ready, setReady] = useState(true)
  const [events, setEvents] = useState([])

  useEffect(() => {
    const reqEvents = async () => {
      const getEvents = await doRequestGet({
        url: '/worker/events'
      })
      setEvents(getEvents.data)
    }
    reqEvents()
  }, [])


  const getReport = async () => {
    try {
      setReady(false)
      const getEvents = await doRequestPost({
        url: '/report/general',
        data: form
      })

      if (getEvents.data.rows_count === 0) {
        doToast({
          response: 'warning',
          message: 'No hay registros encontrados',
          toast
        })
        setReport({})
        return
      }

      setReport(getEvents.data)
    } catch (error) {

    } finally {
      setReady(true)
    }
  }

  return <div className='row'>
    <div className="col-12">
      <Card>
        <Card.Body>
          <FormCustom onSubmit={_ => {
            if (!isNaN(parseInt(form.p_id_event))) {
              getReport()
            } else {
              doToast({
                response: 'warning',
                message: 'Seleccione un evento',
                toast
              })
            }
          }} viewSubmit={false}>
            <Input
              classNameParent="col-md-6 mb-2"
              value={form.p_date_start}
              onChange={e => {
                setForm({ ...form, p_date_start: e.target.value })
                setReport({})
              }}
              type="date"
              text="Fecha Inicio"
            />
            <Input
              classNameParent="col-md-6 mb-2"
              value={form.p_date_end}
              onChange={e => {
                setForm({ ...form, p_date_end: e.target.value })
                setReport({})
              }}
              type="date"
              text="Fecha Fin"
            />
            <SelectCustom
              valueId={form.p_id_event}
              keyName="event"
              options={events}
              setRow={setForm}
              row={form}
              selectText="Eventos"
              onChangeAdd={_ => {
                setReport({})
              }}
              selectPops={{
                append: [
                  <Button type="submit">
                    <i className='fa fa-search'></i>
                  </Button>
                ]
              }}
              showEnabled={false}
            />
          </FormCustom>
          {report?.excel?.file ? <div className="d-flex mt-3">
            <div className='me-2'>
              <a href={report?.excel?.file} download={report?.excel?.name}>
                <Button variant="success" className='text-white'>
                  <i className="fa fa-file-excel me-2"></i>Descargar Reporte Excel
                </Button>
              </a>
            </div>
          </div> : ''}
        </Card.Body>
      </Card>
    </div>

    {!ready && <LoadingIcon />}
  </div>
}